import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { retrySolarRead } from "./solar-read-retry"
import type { SolarProposalAuroraDto } from "../dto/solar-proposal-aurora.dto"
import { solarProposalAuroraService } from "../services/solar-proposal-aurora.service"

/**
 * The Solar Proposal's active Aurora design and its stored versions. The
 * gateway reads stored state only; it never calls Aurora for this.
 */
export default function useSolarProposalAurora(
  proposalId: string | undefined,
): UseQueryResult<SolarProposalAuroraDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.aurora(proposalId ?? ``),
    queryFn: () => solarProposalAuroraService.getAurora(proposalId ?? ``),
    enabled: Boolean(proposalId),
    retry: retrySolarRead,
  })
}
